export const name = 'realtimeWixCodeSdk' as const
export const namespace = 'realtime' as const
